<template>
  <div class="privacy-policies">
    <cms-content type="2" :lang="lang"/>
  </div>
</template>

<script>
  import CmsContent from '@/components/CmsContent.vue'
  export default {
    components: {
      CmsContent
    },
    computed:{
      lang(){
        return localStorage.lang
      }
    }
  }
</script>
